import { Environment } from "src/libs/environment";

export const HomeStorage = {
    StaticBanners: `${Environment.string("BLOB_STORAGE_URL")}/images/banners`,
};
